export default __webpack_public_path__ + "static/media/Guru-Parampara-30.fdc877a4.png";